import { FC, SVGProps } from 'react'

import BenchmarkIcon from 'src/components/ui/atoms/Icons/BenchmarkIcon'
import Deal from 'src/components/ui/atoms/Icons/Deal'
import PriceIcon from 'src/components/ui/atoms/Icons/Price'
import ReportIcon from 'src/components/ui/atoms/Icons/Report'
import SafetyBuoyIcon from 'src/components/ui/atoms/Icons/SafetyBuoyIcon'
import { Product } from 'src/utils/product'
import AppStreamIcon from '../Icons/AppStreamIcon'
import ChabotProductIcon from '../Icons/ChatbotProductIcon'
import DataAvaibilityIcon from '../Icons/DataAvaibilityIcon'
import SelfServiceMappingIcon from '../Icons/SelfServiceMappingIcon'

export interface ProductIconProps extends SVGProps<SVGSVGElement> {
  productCode: Product | 'sell' | 'highlights' | 'self_service' | 'data_availability'
}

const ProductIcon: FC<ProductIconProps> = ({ productCode, ...svgProps }) => {
  switch (productCode) {
    case 'report':
      return <ReportIcon {...svgProps} />
    case 'price':
    case Product.PbsYield:
      return <PriceIcon {...svgProps} />
    case Product.STREAM:
      return <AppStreamIcon {...svgProps} />
    case 'sell':
    case 'highlights':
    case 'benchmark':
    case Product.MARKET_INTEL:
      return <BenchmarkIcon {...svgProps} />
    case 'troubleshoot':
      return <SafetyBuoyIcon {...svgProps} />
    case 'deal':
    case Product.DEAL_V2:
      return <Deal {...svgProps} />
    case 'self_service':
      return <SelfServiceMappingIcon {...svgProps} />
    case 'data_availability':
      return <DataAvaibilityIcon {...svgProps} />
    case Product.AI:
      return <ChabotProductIcon {...svgProps} />
    default:
      return null
  }
}

export default ProductIcon
